function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import PerPageSelect from './PerPageSelect';
import Pages from './Pages';
import styles from './Pagination.pcss';
var _React_PureComponent;
class Pagination extends (_React_PureComponent = React.PureComponent) {
    renderPerPageSelect() {
        const { perPage, onPerPageChange, isPerPageOff } = this.props;
        if (isPerPageOff) {
            return null;
        }
        return /*#__PURE__*/ _jsx("div", {
            className: "perPageSelect",
            children: /*#__PURE__*/ _jsx(PerPageSelect, {
                value: perPage,
                onChange: onPerPageChange
            })
        });
    }
    render() {
        const { totalPages, page, pagesSlots } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.pagination,
            children: [
                this.renderPerPageSelect(),
                totalPages > 1 && /*#__PURE__*/ _jsx(Pages, {
                    totalPages: totalPages,
                    activePage: page,
                    slotsNo: pagesSlots,
                    onChange: this.props.onPageChange
                })
            ]
        });
    }
}
_define_property(Pagination, "propTypes", {
    // Explicit props
    perPage: PropTypes.number,
    page: PropTypes.number,
    totalPages: PropTypes.number,
    pagesSlots: PropTypes.number,
    isPerPageOff: PropTypes.bool,
    // Explicit actions
    onPerPageChange: PropTypes.func,
    onPageChange: PropTypes.func
});
_define_property(Pagination, "defaultProps", {
    pagesSlots: 5,
    isPerPageOff: false
});
export default withStyles(styles)(Pagination);
